export const events = {
  NOT_FOUND_404: 'Error Code (404)',
  SEARCH: 'SearchInteraction',
  FILTER_COLOR: 'filter_colour',
  FILTER_STORE: 'filter_store',
  FILTER_BRAND: 'filter_brand',
  FILTER_PRICE: 'filter_price',
  SELECT_CATEGORY: 'category_selection',
  PRODUCTS_CENTRE_SELECTED: 'select_centre',
  PRODUCTS_SORT_SELECTED: 'sort_by',
  PRODUCTS_PAGE_PREV_NEXT_SELECTED: 'next_prev_arrow',
  PRODUCTS_PAGE_NEXT_SELECTED: 'next_prev_arrow',
  PRODUCTS_VIEW_PRODUCT: 'productDetail',
  PRODUCTS_BUY_NOW: 'addToCart',
  PRODUCTS_SHOW_MORE_DETAIL: 'more_less_click',
  PRODUCTS_BREADCRUMB: 'breadcrumb_click',
  PRODUCTS_CLICK: 'productClick',
  STORE_CLICK: 'store_click',
  PRODUCT_IMPRESSION: 'productImpression',
  PRODUCTS_MENU_CLICK: 'products_click',
  USER_CLICK: 'user_interaction',
  MOVIES: 'movie_interaction',
  MODULE_IMPRESSION: 'module_impression',
  PROMOTION_IMPRESSION: 'promoImpression',
  DATA_LAYER: 'dataLayer',
  PROMOTION_CLICK: 'promoClick',
  WHATS_ON_FILTERS: 'whatson-filter',
}

export const categories = {
  CENTRE_SEARCH: 'centreSearch',
  GLOBAL_SEARCH: 'globalSearch',
  STORE_SEARCH: 'storeSearch',
  PRODUCT_FILTER: 'Filter',
  CATEGORY_SELECTION: 'Category Selection',
  MORE_LESS_CLICK: 'More Less Click',
  BREADCRUMB_CLICK: 'Breadcrumb Click',
  STORE_SELECTION: 'Store Selection',
  DROPDOWN_CLICK: 'Products Dropdown Click',
  EVENT_DETAILS_INTERACTION: 'Event Details Interaction',
  GIFTCARD_CLICK: 'Gift Card',
  DIGITAL_GIFT_CARD: 'Digital Gift Card',
  MOVIE_NOT_FOUND: 'Movie not found, redirect',
  SETTINGS_CLICK: 'Change setting',
  PROMOTION_CTA: 'Promotion Module CTA Click',
  USER_GENERATED_CONTENT: 'User Generated Content',
  SPOTLIGHT_CTA: 'Spotlight CTA',
  NEWS_CTA: 'News CTA',
  WHATS_HAPPENING_FEATURED: 'Whats Happening - Featured',
  WHATS_HAPPENING_CENTER: 'Whats Happening - Centre Page',
  WHATS_HAPPENING_DECK: 'Whats Happening Deck',
  EVENT_SHARE: 'Event - Share',
  PAGE_SHARE: 'Page - Share', // (fallback for non-specific)
  WESTFIELD_PLUS_CLICK: 'Westfield Plus',
  FEATURE_CTA: 'Feature module CTA',
  COMPARISON_MODULE_BUY: 'Comparison module Buy',
  COMPARISON_MODULE_CTA: 'Comparison module CTA',
  CORP_MODULE_CTA: 'Corp module CTA',
  CHINA_WESTFIELD_CLICK: 'china.westfield',
  WHATS_HAPPENING_FILTERS: 'Whats Happening Filters',
  WHATS_HAPPENING_SEE_MORE: 'Whats Happening Page',
}

export const actions = {
  CAL_DOWNLOAD_LINK: 'Download Calendar Invite',
  CLICK_TO_START_SEARCH: 'clickToStartSearch',
  CLICK_TO_CLEAR_SEARCH_KEYWORD: 'clickToClearSearchKeyword',
  CLICK_TO_CLOSE_SEARCH: 'clickToCloseSearch',
  CLICK_TO_SEE_ALL_CENTRES: 'clickToSeeAllCentres',
  CLICK_TO_SET_LOCATION: 'clickToSetGeolocation',
  CLICK_TO_SET_LOCATION_DENIED: 'clickToSetGeolocationDenied',
  SEARCH_SHOWN: 'searchShown',
  SEARCH_RESULT_ClICKED: 'searchResultClicked',
  STORE_CATEGORY_CLICKED: 'storeCategoryClicked',
  STORE_SUB_CATEGORY_CLICKED: 'storeSubCategoryClicked',
  STORE_GIFTCARD_FILTER: 'storeGiftcardCheckbox',
  STORE_AFTERPAY_FILTER: 'storeAfterpayCheckbox',
  STORE_DISPLAY_GRID_LIST: 'storeDisplayGridOrList',
  SORT: 'Sort',
  FILTER_COLOR: 'Colour',
  FILTER_STORE: 'Store',
  FILTER_BRAND: 'Brand',
  FILTER_PRICE: 'Price',
  MORE: 'More',
  LESS: 'Less',
  SELECT_CATEGORY_FROM_FILTER: 'Left Navigation Panel',
  SELECT_CATEGORY_FROM_HOMEPAGE: 'Homepage',
  BREADCRUMB: {
    ROOT: 'Products',
    T1: 'T1',
    T2: 'T2',
    T3: 'T3',
  },
  CLICK: 'Click',
  GIFTCARD_NAT_HOME: 'Nat Home Module',
  GIFTCARD_NAT_HOME_TEXT: 'Nat Home Text Link',
  GIFTCARD_NAV_CLICK: 'Navigation Menu',
  GIFTCARD_NAV_ICON_CLICK: 'Navigation Icon',
  GIFTCARD_STOREFRONT_CLICK: 'Storefront link',
  MOVIE_NOT_FOUND_ROUTE: 'Movie not found, user redirected to movies',
  INSTA_DECK_SHOW: 'Instagram Deck Displayed',
  INSTA_DECK_TILE: 'Instagram Deck Enlarge tile (mobile only)',
  INSTA_DECK_LINK: 'Instagram Deck Link',
  INSTA_DECK_SCROLL: 'Instagram Deck Scrolled',
  REVIEWS_MODULE_SHOW: 'Reviews module displayed',
  REVIEWS_SEE_MORE: 'Reviews module show more',
  STORES_SEE_MORE: 'Stores See More',
  NEWS_SEE_MORE: 'See More News',
  SHARE_THIS_EVENT: 'Share this event',
  SHARE_THIS_PAGE: 'Share this page', // (fallback for non-specific)
  SHARE_TO_FACEBOOK: 'Share to facebook',
  CANCEL_SHARE: 'Cancel share',
  WESTFIELD_PLUS_NAV_CLICK: 'Navigation Menu',
  CHINA_WESTFIELD_NAV_CLICK: 'Centre Navbar Text Link',
  GIFTCARD_FOOTER_CLICK: 'Footer Click',
  GIFTCARD_CART_CLICK: 'CART Header Title',
  GIFTCARD_HEADER_CLICK: 'GC Header Title',
  CTA: 'CTA',
  DATE_SELECT: 'Date Select',
  FILTER_SELECT: 'Filter Select',
  FILTER_DESELECT: 'Filter Deselect',
  DATE_RANGE_EXPAND: 'Date Range Expand',
  DATE_RANGE_SELECT: 'Date Range Select',
  RESET_FILTERS: 'Reset Filters',
  EXPAND_FILTERS: 'Expand Filters',
  COLLAPSE_FILTERS: 'Collapse Filters',
}
export const settings = {
  SCROLL_HORIZONTAL_THRESHOLD: 200,
}

export const positions = {
  FEATURED_CONTENT: 'Whats Happening - Featured',
  WHATS_HAPPENING_CENTRE: 'Whats Happening - Centre Page',
  SPOTLIGHT: 'Spotlight - Featured',
}

export const names = {
  SPOTLIGHT: 'Spotlight',
}

export const dimensions = {
  DIMENSION90: '8',
}

export const labels = {
  ARROW_LEFT: 'Arrow Left',
  ARROW_RIGHT: 'Arrow Right',
  CLICK_TEXT: 'Click text',
  EXPAND: 'Expand',
}
